<style>
  .filesContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 20px;
  }
  .fileContainer {
    flex: 0 0 calc(50% - 20px);
    box-sizing: border-box;
  }
  @media (max-width: 700px) {
    .filesContainer {
      flex-direction: column;
      gap: 0px;
    }
    .fileContainer {
      flex: 1;
      box-sizing: border-box;
    }
  }
</style>

<div class="sectionContainer paddedContent containerMargins">
  <div class="containerMargins filesContainer">
    @for (f of attachments; track f) {
      <div
        class="sectionContainer fileContainer"
        (mouseover)="showDelete(f.id)"
        (mouseout)="hideDelete()"
      >
        <div
          style="
            display: flex;
            justify-content: start;
            align-items: center;
            gap: 15px;
          "
          class="paddedContent"
        >
          <div
            style="
              flex: 5;
              display: flex;
              justify-content: start;
              align-items: center;
              gap: 15px;
            "
          >
            <div style="vertical-align: top">
              <app-icon [type]="'File'" [class]="'medium'"></app-icon>
            </div>
            <div style="flex: 1">
              <h4 style="margin-bottom: 3px !important; padding-bottom: 0px">
                {{ f.label }}
              </h4>
              <!-- <div style="margin-bottom:7px; font-style: italic; font-size:.9em;">Uploaded on {{formatDate(f.updatedAt.toString())}}</div> -->
              <div>{{ f.filename }}</div>
            </div>
            <div style="margin-left: auto">
              <app-button-input
                [icon]="'OpenInNewWindow'"
                (click)="btnOpen_click(f)"
                [title]="'Open file'"
                [hidden]="rolloverId != f.id"
              ></app-button-input>
              &nbsp;&nbsp;
              <app-button-input
                [icon]="'Download'"
                (click)="btnDownload_click(f)"
                [title]="'Download file'"
                [hidden]="rolloverId != f.id"
              ></app-button-input>
              &nbsp;&nbsp;
              <app-button-input
                [icon]="'MinusRemove'"
                (click)="btnDelete_click(f)"
                [title]="'Delete file'"
                [hidden]="rolloverId != f.id"
              ></app-button-input>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div style="margin-bottom: 10px">
    <!--
    since we can't really style a native file input, we just hide it
    and trigger its click event from our own, visible button
    -->
    <input
      type="button"
      value="Select files"
      class="button_primary button_var_2"
      style="padding: 15px 20px"
      (click)="selectFiles_click()"
    />
    <input
      type="file"
      id="fileUpload"
      multiple="true"
      style="width: 0px; height: 0px"
      (change)="onFilesSelected($event)"
    />
  </div>

  <div style="display: flex; gap: 20px">
    <div style="flex: 0 0 calc(50% - 20px); box-sizing: border-box">
      <div
        style="flex: 1"
        class="drop-zone"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onFileDrop($event)"
      >
        Drag your files here to upload
      </div>
    </div>

    <div style="flex: 0 0 calc(50% - 20px); box-sizing: border-box">
      @for (f of fileUploads; track f; let i = $index) {
        <div class="sectionContainer paddedContent" style="margin-bottom: 7px">
          <div style="margin-bottom: 15px; font-style: italic">
            {{ f.file.name }}
          </div>
          <div style="display: flex; vertical-align: top">
            <div style="vertical-align: top">
              <app-ddl-input
                [label]="'Attachment type'"
                [options]="attachmentTypes"
                [readonly]="false"
                [required]="true"
                [(ngModel)]="fileUploads[i].type"
              ></app-ddl-input>
              <div
                style="vertical-align: top"
                [hidden]="fileUploads[i].type != 'Other'"
              >
                <app-text-input
                  [label]="'Other type'"
                  [readonly]="false"
                  [required]="true"
                  [(ngModel)]="fileUploads[i].otherType"
                ></app-text-input>
              </div>
              <div style="vertical-align: top">
                <app-multiline-input
                  [label]="'Notes'"
                  [rows]="2"
                  [readonly]="false"
                  [required]="false"
                  [(ngModel)]="fileUploads[i].notes"
                ></app-multiline-input>
              </div>
            </div>
            <div style="padding-left: 30px">
              <input
                type="button"
                value="Remove"
                class="button_secondary button_var_3"
                (click)="removeUpload_click(i)"
              />
            </div>
          </div>
        </div>
      }

      <div [hidden]="!fileUploads || fileUploads.length == 0">
        <input
          type="button"
          [disabled]="!validateUploads()"
          value="Upload {{ fileUploads.length == 1 ? 'this' : 'these' }} file{{
            fileUploads.length == 1 ? '' : 's'
          }}"
          class="button_primary button_var_2"
          (click)="uploadFiles()"
          [title]="
            validateUploads()
              ? 'Upload'
              : 'Please select a file type for each file'
          "
        />
      </div>
    </div>
  </div>
</div>
